import { connect } from "react-redux";

import { get_token } from "./actions/queries";
//import { mergeProps } from '../../mergeProps';

function mapStateToProps(state) {
  return {
    impersonate: state.impersonate,
    fetched: state.impersonate.fetched,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getTokenForImpersonate: (id, savelend) => {
      dispatch(get_token(id, savelend));
    },
  };
}

const impersonateService = connect(mapStateToProps, mapDispatchToProps);
export default impersonateService;
